







import TransactionsView from '@/components/TransactionsView.vue'
import { AgencyBalanceTransactionsType } from '@/api/Agency/agency.interface'

import Vue from 'vue'
import { agencyBalanceTransactionsController } from '@/api/Agency/agency.api'
export default Vue.extend({
  components: {
    TransactionsView,
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      types: this.$utils.makeSelectable(AgencyBalanceTransactionsType),
      controller: agencyBalanceTransactionsController,
    }
  },
})
